<template>
    <button :type="type" class="btn btn-outline-primary">
        <i class="bi" :class="icon"></i>
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'ButtonDomAdd',
    props: {
        text: {
            type: String,
            default: '行追加',
        },
        icon: {
            type: String,
            default: 'bi-plus-lg',
        },
        type: {
            type: String,
            default: 'button',
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
